import React from 'react';
import ReactDOM from 'react-dom';
import {
    HashRouter,
    Routes,
    Route,
  } from "react-router-dom";
import App from './App';
import Resume from './Resume';
import About from './About';
import Projects from './Projects';

const root = ReactDOM.createRoot(
    document.getElementById("root")
);

root.render(
    <HashRouter>
        <Routes>
            <Route path="/" element={<App />} />
            <Route path="about" element={<About />} />
            <Route path="projects" element={<Projects />} />
            <Route path="resume" element={<Resume />} />
        </Routes>
    </HashRouter>
);